import { DataProvider, ListComponent } from "../../GenericList"
import { configData } from "./ads-config"
import { AdsConfigComponent } from "./AdsConfigComponent"

/**
 * Admin section for the top-level "ads" Firestore collection shown on the
 * consumer app's Home screen, plus the adsConfig display-settings doc.
 */
export const AdsComponent = () => {
  return (
    <div>
      <AdsConfigComponent />
      <DataProvider {...configData}>
        <ListComponent />
      </DataProvider>
    </div>
  )
}

export default AdsComponent
